export const ActionTypes = {
  FETCH_AUTHORIZED_USERS: 'services/userDetail/fetch_authorized_users',
  SET_AUTHORIZED_USERS: 'services/userDetail/set_authorized_users',
  FETCH_USER_ROLES: 'services/userDetail/fetch_user_roles',
  SET_USER_ROLES: 'services/userDetail/set_user_roles',
  UPDATE_USER_ROLE: 'services/userDetail/update_user_role',
  FETCH_USER_ROLE_DETAILS: 'services/userDetail/fetch_user_role_details',
  SET_USER_ROLE_DETAILS: 'services/userDetail/set_user_role_details',
  FETCH_USER_AREAS: 'services/userDetail/fetch_user_areas',
  SET_USER_AREAS: 'services/userDetail/set_user_areas',
  SET_USER_ROLE_DETAILS_LOADER_STATUS: 'services/userDetail/set_user_role_details_loader_status',
  SET_AUTHORIZED_USERS_LOADER_STATUS: 'services/userDetail/set_authorized_users_loader_status',

  ADD_USER_ROLE: 'services/userDetail/add_user_role',
  UPDATE_USER_AREA_ROLES: 'services/userDetail/update_user_area_roles',
  FETCH_APP_NOTIFICATIONS: 'services/userDetail/fetch_app_notifications',
  SET_APP_NOTIFICATIONS: 'services/userDetail/set_app_notifications',
  DISMISS_APP_NOTIFICATIONS: 'services/userDetail/dismiss_app_notification',
  DISMISS_ALL_APP_NOTIFICATIONS: 'services/userDetail/dismiss_all_app_notification',
  FETCH_USER_NOTIFICATIONS: 'services/userDetail/fetch_user_notifications',
  SET_USER_NOTIFICATIONS: 'services/userDetail/set_user_notifications',
  ADD_NOTIFICATION_SETTING: 'services/userDetail/add_notification_setting',
  ADD_NOTIFICATION_PREFERENCE: 'services/userDetail/add_notification_preference',
  UPDATE_USER_CONTACT_DATA: 'services/userDetail/update_user_contact_data',
  SET_USER_NOTIFICATIONS_LOADER_STATUS: 'services/userDetail/set_user_notifications_loader_status',
};

const fetchAuthorizedUsers = () => ({
  type: ActionTypes.FETCH_AUTHORIZED_USERS,
});

const setAuthorizedUsers = ({ authorizedUsersData }) => ({
  authorizedUsersData,
  type: ActionTypes.SET_AUTHORIZED_USERS,
});

const fetchUserRoles = () => ({
  type: ActionTypes.FETCH_USER_ROLES,
});

const setUserRoles = ({ userRolesData }) => ({
  userRolesData,
  type: ActionTypes.SET_USER_ROLES,
});

const fetchUserRoleDetails = () => ({
  type: ActionTypes.FETCH_USER_ROLE_DETAILS,
});

const setUserRoleDetails = ({ userRoleDetailsData }) => ({
  userRoleDetailsData,
  type: ActionTypes.SET_USER_ROLE_DETAILS,
});

const fetchUserAreas = () => ({
  type: ActionTypes.FETCH_USER_AREAS,
});

const setUserAreas = ({ userAreasData }) => ({
  userAreasData,
  type: ActionTypes.SET_USER_AREAS,
});

const updateUserRole = ({ userRole }) => ({
  userRole,
  type: ActionTypes.UPDATE_USER_ROLE,
});

const setUserRoleDetailsLoaderStatus = ({ UserRoleDetailsLoader }) => ({
  UserRoleDetailsLoader,
  type: ActionTypes.SET_USER_ROLE_DETAILS_LOADER_STATUS,
});

const setAuthorizedUsersLoaderStatus = ({ authorizedUsersLoader }) => ({
  authorizedUsersLoader,
  type: ActionTypes.SET_AUTHORIZED_USERS_LOADER_STATUS,
});

const addUserRole = ({ userRole }) => ({
  userRole,
  type: ActionTypes.ADD_USER_ROLE,
});

const updateUserAreaRoles = ({ userAreaRoles }) => ({
  userAreaRoles,
  type: ActionTypes.UPDATE_USER_AREA_ROLES,
});

const fetchUserNotifications = ({ notificationSettingsParams }) => ({
  notificationSettingsParams,
  type: ActionTypes.FETCH_USER_NOTIFICATIONS,
});

const setUserNotifications = ({ notificationSettingsData }) => ({
  notificationSettingsData,
  type: ActionTypes.SET_USER_NOTIFICATIONS,
});

const setUserNotificationsLoaderStatus = ({ notificationSettingsLoader }) => ({
  notificationSettingsLoader,
  type: ActionTypes.SET_USER_NOTIFICATIONS_LOADER_STATUS,
});

const addNotificationSetting = ({ addSettingModal }) => ({
  addSettingModal,
  type: ActionTypes.ADD_NOTIFICATION_SETTING,
});

const addNotificationPreference = ({ addPreferenceModal, notificationSettingsParams }) => ({
  addPreferenceModal,
  notificationSettingsParams,
  type: ActionTypes.ADD_NOTIFICATION_PREFERENCE,
});

const updateUserContactData = ({ userContactData, notificationSettingsParams }) => ({
  userContactData,
  notificationSettingsParams,
  type: ActionTypes.UPDATE_USER_CONTACT_DATA,
});

const fetchAppNotifications = ({ userId }) => ({
  userId,
  type: ActionTypes.FETCH_APP_NOTIFICATIONS,
});

const setAppNotifications = ({ appNotifications }) => ({
  appNotifications,
  type: ActionTypes.SET_APP_NOTIFICATIONS,
});

const dismissAppNotification = ({ id, comment }) => ({
  id,
  comment,
  type: ActionTypes.DISMISS_APP_NOTIFICATIONS,
});

const dismissAllAppNotification = ({ comment }) => ({
  comment,
  type: ActionTypes.DISMISS_ALL_APP_NOTIFICATIONS,
});

export default {
  fetchAuthorizedUsers,
  setAuthorizedUsers,
  fetchUserRoles,
  setUserRoles,
  updateUserRole,
  setAuthorizedUsersLoaderStatus,
  fetchUserRoleDetails,
  setUserRoleDetails,
  fetchUserAreas,
  setUserAreas,
  setUserRoleDetailsLoaderStatus,
  addUserRole,
  updateUserAreaRoles,
  fetchUserNotifications,
  setUserNotifications,
  setUserNotificationsLoaderStatus,
  addNotificationSetting,
  addNotificationPreference,
  updateUserContactData,
  fetchAppNotifications,
  setAppNotifications,
  dismissAppNotification,
  dismissAllAppNotification,
};
